import _ from 'lodash';

class PolicyParticipation {
  constructor (data = {}) {
    this.policyNumber = data.policyNumber;
    this.fromDate = data.fromIsoDate;
    this.untilDate = data.untilIsoDate;

    this.isActive = this.isActiveOnDate(); // data.isActive;

    if (data.participationDetails != null) {
      this.policyParticipationDetails = data.participationDetails
        .map(p => new PolicyParticipationDetail(p));
    } else this.policyParticipationDetails = [];

    this.hasActiveWaiver = _.some(this.policyParticipationDetails, p => p.isActiveWaiver);
    if (this.hasActiveWaiver) {
      this.untilDate = this.policyParticipationDetails.find(p => p.isActiveWaiver).fromDate;
    }
  }

  isActiveOnDate (date) {
    let _date = null;
    if (date == null) {
      _date = new Date();
    } else _date = new Date(date);

    if (this.fromDate == null || this.fromDate === '') return false;
    if (_date >= new Date(this.fromDate)) {
      if (this.untilDate == null || this.untilDate === '') return true;

      // untilDate should be expiryDate as discussed
      if (_date <= new Date(this.untilDate)) return true;
      else return false;
    }

    return false;
  }

  isActiveWaiverOnDate (date) {
    return _.some(this.policyParticipationDetails, p => p.isActiveWaiverOnDate(date));
  }
}

class PolicyParticipationDetail {
  constructor (data = {}) {
    this.fromDate = data.fromIsoDate;
    this.untilDate = data.untilIsoDate;
    this.hasWaiver = data.hasWaiver;

    this.isActiveWaiver = this.isActiveWaiverOnDate();
  }

  isActiveWaiverOnDate (date) {
    let _date = null;
    if (date == null) {
      _date = new Date();
    } else _date = new Date(date);

    if (this.fromDate == null || this.fromDate === '') return false;
    if (this.untilDate == null || this.untilDate === '') {
      return this.hasWaiver;
    } else {
      if (_date >= new Date(this.fromDate) && _date <= new Date(this.untilDate)) {
        // might have waiver but today is not between its from-until range. therefore always false.
        return this.hasWaiver;
      } else {
        return false;
      }
    }
  }
}

export {
  PolicyParticipation,
  PolicyParticipationDetail
};
